// SEO Configuration for HK Altbausanierung
// Zentrale SEO-Daten für die gesamte Website

export const SITE_URL = "https://hk-altbausanierung.com";

export const DEFAULT_SEO = {
  siteName: "HK Altbausanierung",
  title: "Altbausanierung Stuttgart & Region | HK Altbausanierung",
  description: "Fassadensanierung, Dachsanierung, Innen- und energetische Sanierung in Stuttgart & Region. Unverbindliche Besichtigung – jetzt anfragen.",
  locale: "de_DE",
  type: "website",
  image: `${SITE_URL}/og.jpg`,
  imageWidth: 1200,
  imageHeight: 630,
  imageAlt: "HK Altbausanierung - Altbausanierung in Stuttgart"
};

// Page-specific SEO data
export const PAGE_SEO = {
  home: {
    title: "Altbausanierung Stuttgart & Region | HK Altbausanierung",
    description: "Fassadensanierung, Dachsanierung, Innen- und energetische Sanierung in Stuttgart & Region. Unverbindliche Besichtigung – jetzt anfragen.",
    canonical: SITE_URL
  },
  leistungen: {
    title: "Unsere Leistungen | HK Altbausanierung",
    description: "Professionelle Altbausanierung in Stuttgart: Fassaden, Dach, Innenräume und energetische Sanierung. Alle Leistungen im Überblick.",
    canonical: `${SITE_URL}/leistungen`
  },
  fassadensanierung: {
    title: "Fassadensanierung Stuttgart | Historische Fassaden restaurieren",
    description: "Professionelle Restaurierung und Modernisierung historischer Fassaden in Stuttgart & Region. Hochwertige Materialien, saubere Ausführung.",
    canonical: `${SITE_URL}/leistungen/fassadensanierung-stuttgart`,
    h1: "Fassadensanierung in Stuttgart"
  },
  dachsanierung: {
    title: "Dachsanierung Stuttgart | Dachrestaurierung & Energiestandards",
    description: "Komplette Dachsanierung in Stuttgart & Region – für Altbau und Neubau. Jetzt Angebot anfordern.",
    canonical: `${SITE_URL}/leistungen/dachsanierung-stuttgart`,
    h1: "Dachsanierung in Stuttgart"
  },
  innensanierung: {
    title: "Innensanierung Stuttgart | Modernisieren mit Substanz",
    description: "Umfassende Innensanierung in Stuttgart: historische Elemente erhalten, moderne Haustechnik integrieren. Planung & Umsetzung.",
    canonical: `${SITE_URL}/leistungen/innensanierung-stuttgart`,
    h1: "Innensanierung in Stuttgart"
  },
  energetischeSanierung: {
    title: "Energetische Sanierung Stuttgart | Effizient modernisieren",
    description: "Energieeffiziente Sanierung in Stuttgart & Region – Substanz erhalten, Verbrauch senken, Wert steigern.",
    canonical: `${SITE_URL}/leistungen/energetische-sanierung-stuttgart`,
    h1: "Energetische Sanierung in Stuttgart"
  },
  referenzen: {
    title: "Referenzen & Projekte | HK Altbausanierung Stuttgart",
    description: "Unsere abgeschlossenen Sanierungsprojekte in Stuttgart & Region. Überzeugen Sie sich von unserer Arbeit.",
    canonical: `${SITE_URL}/referenzen`
  },
  ueberUns: {
    title: "Über uns | HK Altbausanierung Stuttgart",
    description: "Seit 2012 Ihr zuverlässiger Partner für Altbausanierung in Stuttgart. Erfahren Sie mehr über unser Team und unsere Qualifikationen.",
    canonical: `${SITE_URL}/ueber-uns`
  },
  kontakt: {
    title: "Kontakt | HK Altbausanierung Stuttgart",
    description: "Kontaktieren Sie HK Altbausanierung für eine unverbindliche Besichtigung und Beratung in Stuttgart & Region.",
    canonical: `${SITE_URL}/kontakt`
  },
  impressum: {
    title: "Impressum | HK Altbausanierung",
    description: "Impressum und rechtliche Angaben zu HK Altbausanierung, Haxhi Kyreziu.",
    canonical: `${SITE_URL}/impressum`
  },
  datenschutz: {
    title: "Datenschutzerklärung | HK Altbausanierung",
    description: "Datenschutzerklärung der HK Altbausanierung Website gemäß DSGVO.",
    canonical: `${SITE_URL}/datenschutz`
  }
};

// Company Info for Schema.org
export const COMPANY_INFO = {
  name: "HK Altbausanierung",
  legalName: "Haxhi Kyreziu - HK Altbausanierung",
  url: SITE_URL,
  logo: `${SITE_URL}/images/logo-hk-v2.png`,
  image: `${SITE_URL}/og.jpg`,
  telephone: "+49 172 9308274",
  telephoneLandline: "+49 7163 5357890",
  email: "hk-altbausanierung@outlook.de",
  address: {
    streetAddress: "Gartenstraße 16",
    postalCode: "73061",
    addressLocality: "Ebersbach an der Fils",
    addressCountry: "DE"
  },
  areaServed: ["Stuttgart", "Region Stuttgart", "Baden-Württemberg"],
  foundingDate: "2012",
  knowsAbout: [
    "Fassadensanierung",
    "Dachsanierung", 
    "Innensanierung",
    "Energetische Sanierung",
    "Altbausanierung"
  ]
};

// Service data with SEO-optimized content
export const SERVICES_SEO = {
  fassadensanierung: {
    slug: "fassadensanierung-stuttgart",
    name: "Fassadensanierung in Stuttgart",
    serviceType: "Fassadensanierung / Fassadenrestaurierung",
    shortDescription: "Professionelle Restaurierung und Modernisierung historischer Fassaden mit hochwertigen Materialien und traditioneller Handwerkskunst.",
    longDescription: `Unsere Fassadensanierung in Stuttgart und Umgebung umfasst die fachgerechte Restaurierung und Modernisierung historischer Gebäudefassaden. Mit hochwertigen Materialien und traditioneller Handwerkskunst bewahren wir den Charakter Ihres Altbaus, während wir gleichzeitig moderne Standards erfüllen.

Unsere Leistungen im Bereich Fassadensanierung:
• Reinigung und Aufarbeitung historischer Fassadenelemente
• Risssanierung und Putzausbesserung
• Fassadenanstrich mit hochwertigen Farben
• Natursteinarbeiten und Ornamentrestaurierung
• Wärmedämmverbundsysteme (WDVS) für Altbauten
• Balkon- und Erkersanierung`,
    image: "/images/service-fassade.jpg",
    imageAlt: "Fassadensanierung eines historischen Gebäudes in Stuttgart"
  },
  dachsanierung: {
    slug: "dachsanierung-stuttgart",
    name: "Dachsanierung in Stuttgart",
    serviceType: "Dachsanierung / Dachrestaurierung",
    shortDescription: "Komplette Dachsanierung und -restaurierung unter Berücksichtigung moderner Energiestandards.",
    longDescription: `Professionelle Dachsanierung für Altbauten in Stuttgart und Region. Wir sanieren Ihr Dach fachgerecht unter Berücksichtigung moderner Energiestandards.

Unsere Leistungen im Bereich Dachsanierung:
• Komplettsanierung von Steildächern und Flachdächern
• Dachstuhlsanierung und Holzschutz
• Neueindeckung mit hochwertigen Materialien
• Dachdämmung nach EnEV
• Dachfenstereinbau und -austausch
• Dachrinnen und Blecharbeiten
• Schornsteinsanierung`,
    image: "/images/service-dach.jpg",
    imageAlt: "Dachsanierung eines Altbaus in Stuttgart"
  },
  innensanierung: {
    slug: "innensanierung-stuttgart",
    name: "Innensanierung in Stuttgart",
    serviceType: "Innensanierung / Innenraummodernisierung",
    shortDescription: "Umfassende Modernisierung von Innenräumen mit Erhalt historischer Elemente und Integration moderner Haustechnik.",
    longDescription: `Unsere Innensanierung verbindet den Erhalt historischer Bausubstanz mit modernem Wohnkomfort. Wir sanieren Innenräume in Stuttgart fachgerecht und bewahren dabei den einzigartigen Charakter Ihres Altbaus.

Unsere Leistungen im Bereich Innensanierung:
• Stuck- und Ornamentrestaurierung
• Boden- und Parkettaufarbeitung
• Trockenbau und Raumaufteilung
• Elektro- und Sanitärinstallation
• Malerarbeiten und Tapezierung
• Fenster- und Türenrestaurierung
• Treppensanierung`,
    image: "/images/service-innen.jpg",
    imageAlt: "Innensanierung eines historischen Gebäudes in Stuttgart"
  },
  energetischeSanierung: {
    slug: "energetische-sanierung-stuttgart",
    name: "Energetische Sanierung in Stuttgart",
    serviceType: "Energetische Sanierung / Energieeffiziente Modernisierung",
    shortDescription: "Energieeffiziente Modernisierung unter Wahrung der Gebäudesubstanz für nachhaltigen Werterhalt.",
    longDescription: `Energetische Sanierung für Altbauten in Stuttgart – wir senken Ihren Energieverbrauch, steigern den Wohnkomfort und erhalten dabei die historische Bausubstanz. Profitieren Sie von Fördermitteln und langfristiger Wertsteigerung.

Unsere Leistungen im Bereich energetische Sanierung:
• Fassadendämmung (WDVS, Innendämmung)
• Dachdämmung und Dachbodendämmung
• Fensteraustausch und -sanierung
• Kellerdeckendämmung
• Heizungsmodernisierung
• Energieberatung und Fördermittelberatung`,
    image: "/images/service-energie.jpg",
    imageAlt: "Energetische Sanierung eines Altbaus in Stuttgart"
  }
};
